<template>
    <div
      ref="scrollContainer"
      class="scroll-container"
      @scroll="handleScroll"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div
        ref="refresh"
        class="refresh"
        :style="{ height: refreshHeight + 'px', transform: `translate3d(0, ${refreshOffset}px, 0)` }"
      >
        <div v-if="refreshing">{{ refreshText }}</div>
        <div v-else>{{ pullText }}</div>
      </div>
      <div ref="contentContainer" class="content-container">
      <slot></slot>
    </div>
      <div ref="loadMore" class="load-more" v-if="showLoadMore">
        <div v-if="loading">{{ loadingText }}</div>
        <div v-else>{{ loadMoreText }}</div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        startY: 0,
        startTop: 0,
        refreshing: false,
        loading: false,
        refreshHeight: 0,
        refreshOffset: 0,
        scrollTop:0,
        deltaY:0,
        isAtBottom:false,
      };
    },
    props: {
      pullText: {
        type: String,
        default: ''
      },
      releaseText: {
        type: String,
        default: ''
      },
      refreshingText: {
        type: String,
        default: ''
      },
      refreshThreshold: {
        type: Number,
        default: 50
      },
      refreshMethod: {
        type: Function,
        default: () => {}
      },
      loadMoreText: {
        type: String,
        default: ''
      },
      loadingText: {
        type: String,
        default: ''
      },
      loadMoreMethod: {
        type: Function,
        default: () => {}
      }
    },
    computed: {
      showLoadMore() {
        return !this.refreshing && this.loading;
      }
    },
   
   
    methods: {
      handleScroll() {
        const scrollContainer = this.$refs.scrollContainer;
        const isAtTop = scrollContainer.scrollTop === 0;
        this.scrollTop = scrollContainer.scrollTop
        const isAtBottom = scrollContainer.scrollHeight - scrollContainer.scrollTop< scrollContainer.clientHeight+1;
        this.isAtBottom = isAtBottom
        if (isAtTop && !this.refreshing) {
          this.refreshHeight = 0;
          this.refreshOffset = 0;
        }
       
        // if (isAtBottom && !this.loading) {
        //   this.loading = true;
        //   this.loadMoreMethod();
        // }
      },
      handleTouchStart(event) {
        const touch = event.touches[0];
        this.startY = touch.clientY;
        this.startTop = this.$refs.scrollContainer.scrollTop;
      },
      handleTouchMove(event) {
        if (this.refreshing) return;
        const touch = event.touches[0];
        const deltaY = touch.clientY - this.startY;
        const slotContainerHeight = this.$refs.contentContainer.offsetHeight;
        const scrollContainerHeight= this.$refs.scrollContainer.offsetHeight;
        if(this.startTop<=0 || (this.isAtBottom||(slotContainerHeight<scrollContainerHeight))) {
          this.deltaY = deltaY;
        }
        // this.deltaY =deltaY
        if (deltaY <= 0 || this.startTop > 0) return;
        event.preventDefault();
        this.refreshHeight = Math.min(deltaY, this.refreshThreshold * 2);
        this.refreshOffset = Math.pow(this.refreshHeight, 0.8);
      },
      handleTouchEnd() {
        
        if (this.refreshing) return;
        if (this.refreshHeight >= this.refreshThreshold) {
          this.refreshing = true;
          this.refreshHeight = this.refreshThreshold;
          this.refreshOffset = this.refreshThreshold;
          this.refreshText = this.refreshingText;
          this.refreshMethod();
        } else {
          this.refreshHeight = 0;
          this.refreshOffset = 0;
          this.refreshText = this.pullText;
        }
        const slotContainerHeight = this.$refs.contentContainer.offsetHeight;
        const scrollContainerHeight= this.$refs.scrollContainer.offsetHeight;
        if ((this.isAtBottom||(slotContainerHeight<scrollContainerHeight)) && this.deltaY < -50) {
            this.loadMoreMethod();
        }
      },
      finishRefresh() {
        this.refreshing = false;
        this.refreshHeight = 0;
        this.refreshOffset = 0;
        this.refreshText = this.pullText;
      },
      finishLoadMore() {
        this.loading = false;
      }
    },
    mounted() {
    
       
    }
  };
  </script>
  
  <style>
  .scroll-container {
    overflow-y: auto;
    position: relative;
    height: 100vh;
  }
  
  .refresh {
    text-align: center;
    font-size: 14px;
    line-height: 40px;
    color: #999;
    position: absolute;
    width: 100%;
    top: -40px;
    transition: transform 0.3s;
  }
  
  .load-more {
    text-align: center;
    font-size: 14px;
    line-height: 40px;
    color: #999;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/scrollLoad.vue